<template>
  <div class="login-page">
    <LoginAsForm />
  </div>
</template>

<script>
import LoginAsForm from "@/components/login/LoginAsForm"
export default {
  name: "LoginAs",
  components: { LoginAsForm },
}
</script>


